import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DisbursementChecklistViewUI from './DisbursementChecklistViewUI'

class DisbursementChecklistViewSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checklist: null,
      checklistExists: false,
      generating: false,
      loading: true,
      errorList: [],
      showErrorModal: false
    }
    this._isMounted = false
  }

  componentDidMount() {
    this._isMounted = true
    this.fetchChecklist()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  fetchChecklist = () => {
    if (!this._isMounted) return

    this.setState({ loading: true })

    const loanId = this.props.loan.loanId

    RestApiUtils.get(
      this.props.context,
      `/api/disbursement-checklist/${loanId}`,
      this.onFetchChecklistCallback,
      null,
      null
    )
  }

  onFetchChecklistCallback = (response) => {
    if (!this._isMounted) return

    this.setState({ loading: false })

    if (response.errorList && response.errorList.length > 0) {
      this.setState({
        checklistExists: false,
        checklist: null,
        errorList: response.errorList
      })
    } else {
      this.setState({
        checklistExists: true,
        checklist: response.checklist,
        errorList: []
      })
    }
  }

  onGenerateClick = () => {
    if (!this._isMounted) return

    this.setState({ generating: true, errorList: [], showErrorModal: false })

    const loanId = this.props.loan.loanId

    RestApiUtils.post(
      this.props.context,
      `/api/disbursement-checklist/generate/${loanId}`,
      this.onGenerateCallback,
      null,
      null
    )
  }

  onGenerateCallback = (response) => {
    if (!this._isMounted) return

    this.setState({ generating: false })

    if (response.errorList && response.errorList.length > 0) {
      this.setState({
        errorList: response.errorList,
        checklistExists: false,
        showErrorModal: true
      })
      console.error('Error generating checklist:', response.errorList)
    } else {
      this.setState({
        checklistExists: true,
        checklist: response.checklist,
        errorList: [],
        showErrorModal: false
      })

      if (this.props.onChecklistGenerated) {
        this.props.onChecklistGenerated()
      }
    }
  }

  onRefreshClick = () => {
    if (!this._isMounted) return

    this.setState({ loading: true, errorList: [], showErrorModal: false })
    this.fetchChecklist()
  }

  onCloseErrorModal = () => {
    this.setState({ showErrorModal: false, errorList: [] })
  }

  render() {
    return (
      <DisbursementChecklistViewUI
        context={this.props.context}
        loan={this.props.loan}
        checklist={this.state.checklist}
        checklistExists={this.state.checklistExists}
        onGenerateClick={this.onGenerateClick}
        onRefreshClick={this.onRefreshClick}
        generating={this.state.generating}
        loading={this.state.loading}
        errorList={this.state.errorList}
        showErrorModal={this.state.showErrorModal}
        onCloseErrorModal={this.onCloseErrorModal}
      />
    )
  }
}

export default DisbursementChecklistViewSF